<template>
  <div>
    <h1 class="page-title"><i class="fal fa-tags"></i> Taggar</h1>
    <div class="tag-container">
      <div class="columns is-multiline">
        <div v-for="tag in tags.items" v-bind:key="tag.tagId" >
          <div class="column is-flex">
            <div class="field">
              <input
              class="input tag-inputs is-inline-input"
              type="text"
              :value="tag.name"
              @click="edit"
              disabled
              />
            </div>
            <button class="button is-inline-button is-info" @click="edit(tag)"><i class="fal fa-edit"></i></button>
            <button class="button is-inline-button is-danger" @click="deleteTag(tag)"><i class="fal fa-trash"></i></button>
          </div>
        </div>
      </div>
    </div>
      <new-button @clicked="createTag()" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewButton from '@/components/actions/CreateNewButton'

export default {
  components: {
    NewButton
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY
    }
  },
  watch: {
  },
  computed: {
    ...mapState({
      tags: state => state.tags.all
    })
  },
  methods: {
    ...mapActions('tags', ['getAll', 'update', 'create', 'delete']),

    deleteTag (tag) {
      this.$confirm('Radera tagg', 'Är du säker på att du vill radera taggen ' + tag.name + '?').then((result) => {
        if (result.value) {
          this.delete(tag.tagId)
          this.getAll()
        }
      })
    },

    createTag () {
      this.$alert({
        title: 'Skapa Tagg',
        input: 'text',
        showCancelButton: true,
        inputValidator: (value) => {
          return !value && 'Fältet kan inte lämnas tomt.'
        }
      }).then((result) => {
        if (result.value) {
          this.create({ name: result.value }).then(() => {
            this.getAll()
          })
        }
      })
    },

    edit (tag) {
      this.$alert({
        title: 'Redigera Tagg',
        input: 'text',
        inputValue: tag.name,
        showCancelButton: true,
        inputValidator: (value) => {
          return !value && 'Fältet kan inte lämnas tomt.'
        }
      }).then((result) => {
        if (result.value) {
          this.update({ tagId: tag.tagId, name: result.value }).then(() => {
            this.getAll()
          })
        }
      })
    }
  },
  created () {
    this.getAll()
  }
}
</script>
<style lang="css" scoped>
.tag-container {
  max-width: 1400px;
  margin: auto;
}

.tag-container > .field {
  width: 15rem;
  margin-bottom: 0.75rem;
}

.button {
  margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/SuperAdmin/TagsPage.vue